module.exports = __webpack_public_path__ + "img/moredetails.98c5da92.svg";